module.exports = __webpack_public_path__ + "img/4.0e5216b4.jpg";